// import { useEffect, useState } from "react";

// const Counter = ({ value, label }) => {
//   const [count, setCount] = useState(0);
//   const [counts, setCounts] = useState(0);

//   useEffect(() => {
//     let start = 0;
//     const duration = 1500;
//     const step = value / (duration / 16);

//     const timer = setInterval(() => {
//       start += step;
//       if (start >= value) {
//         setCount(value);
//         clearInterval(timer);
//       } else {
//         setCount(Math.ceil(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [value]);


//    useEffect(() => {
//     let start = 0;
//     const duration = 1500;
//     const step = value / (duration / 16);

//     const timer = setInterval(() => {
//       start += step;
//       if (start >= value) {
//         setCounts(value);
//         clearInterval(timer);
//       } else {
//         setCounts(Math.ceil(start));
//       }
//     }, 16);

//     return () => clearInterval(timer);
//   }, [value]);

//   return (
//     <>
//     <div className="stat-box">
//       <h2>{count}+</h2>
//       <p>{label}</p>
//     </div>

   

//     </>
//   );
// };

// export default Counter;
 


import { useEffect, useState } from "react";

const Counter = ({ value, label, suffix = "+" }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    let start = 0;
    const duration = 1500;
    const step = value / (duration / 16);

    const timer = setInterval(() => {
      start += step;

      if (start >= value) {
        setCount(value);
        clearInterval(timer);
      } else {
        setCount(Math.ceil(start));
      }
    }, 16);

    return () => clearInterval(timer);
  }, [value]);

  return (
    <div className="stat-box">
      <h2>{count}{suffix}</h2>
      <p>{label}</p>
    </div>
  );
};

export default Counter;